import React from "react";
import { Routes, Route } from "react-router-dom";
import Footer from "./layout/footer/footer";
import Header from "./layout/header/header";
import { routes } from "./routes/routes";
import { Provider } from "react-redux";
import { store } from "./store/store";
import './App.scss';

function App() {

  return (
    <>
      <Provider store={store}>
        <Header />
        <div className="main-body">
          <Routes>
            {routes.map((route) => (
              <Route key={route.id} path={route.path} element={route.component} />
            ))}
          </Routes>
        </div>
        <Footer />
        </Provider>
    </>
  );
}

export default App;
